import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  HostListener
} from '@angular/core';

@Component({
  selector: 'app-hover-tooltip-icon',
  templateUrl: './hover-tooltip-icon.component.html',
  styleUrls: ['./hover-tooltip-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HoverTooltipIconComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() link: string;
  @Input() secStyle = false;
  @Input() inside = false;

  @Input() top;
  @Input() left;

  icon = 'icon-info-tooltip';

  showTooltip = false;

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    event.stopPropagation();
  }
  constructor() {}

  ngOnInit() {}

  toggleTooltipVisibility(e) {
    this.showTooltip = e;
  }
}
